import React, { useState, useCallback } from 'react'
import { Flex, Textarea, IconButton } from '@chakra-ui/react'
import { FiSend } from 'react-icons/fi'

interface ChatInputProps {
  onSend: (message: string) => void
  isLoading: boolean
  placeholder?: string
}

const ChatInput: React.FC<ChatInputProps> = ({
  onSend,
  isLoading,
  placeholder = 'Ask me about finance, investing, or JamiiPesa...'
}) => {
  const [input, setInput] = useState('')

  const handleSend = useCallback(() => {
    const trimmed = input.trim()
    if (!trimmed || isLoading) return
    onSend(trimmed)
    setInput('')
  }, [input, isLoading, onSend])

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault()
        handleSend()
      }
    },
    [handleSend]
  )

  return (
    <Flex p={3} borderTop="1px solid" borderColor="gray.200" bg="white" align="flex-end">
      <Textarea
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        resize="none"
        rows={1}
        maxH="120px"
        mr={2}
        fontSize="sm"
        borderRadius="lg"
        _focus={{ borderColor: 'brand.500', boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)' }}
        disabled={isLoading}
      />
      <IconButton
        aria-label="Send message"
        icon={<FiSend />}
        onClick={handleSend}
        isLoading={isLoading}
        colorScheme="brand"
        borderRadius="lg"
        size="md"
        isDisabled={!input.trim() || isLoading}
      />
    </Flex>
  )
}

export default ChatInput
